import { Injectable } from '@angular/core';
import { ApplicationFormService } from '../application-form/application-form.service';
import { DataService } from '@app/core/services/data.service';
import { ApplicationFormDataService } from '../application-form/application-form-data.service';
import { FormlyFieldConfig } from '@ngx-formly/core';

@Injectable({
    providedIn: 'root'
})
export class SafeguardingService {

    referenceTypes = this.afs.getRefDataModel();
    subscription = this.afs.subscribeRefDataModel((data: any) => {
        this.referenceTypes = data
    });

    constructor(
        private afs: ApplicationFormService,
        private dataService: DataService,
        private afds: ApplicationFormDataService
    ) {
    }

    yesNoMap = [
        {
            "value": false,
            "name": "No"
        },
        {
            "value": true,
            "name": "Yes"
        }
    ];

    fetchForm(): any {
        return [
            {
                wrappers: [ 'connectSection' ],
                props: { htmlClass: 'section' },
                fieldGroup: [
                    {
                        wrappers: [ 'section' ],
                        fieldGroup: [
                            {
                                wrappers: [ 'section' ],
                                props: { htmlClass: 'row' },
                                fieldGroup: [
                                    {
                                        wrappers: [ 'section' ],
                                        props: { htmlClass: 'col-sm-12' },
                                        fieldGroup: [
                                            {
                                                key: "physicalDisability",
                                                type: "radiobuttons",
                                                props: {
                                                    options: this.yesNoMap,
                                                    labelHtmlClass: "control-label",
                                                    activeClass: "active",
                                                    required: true,
                                                    title: "Do you suffer from a physical disability?"
                                                },
                                            },
                                            {
                                                expressions: {
                                                    hide: (field: FormlyFieldConfig) => !(field.model.physicalDisability == true && field.model.applicationForm == 'ops')
                                                },
                                                key: "physicalDisabilityInfo",
                                                type: "textarea",
                                                props: {
                                                    required: true,
                                                    title: "Please provide details of how it affects/has affected your daily life and details of any support you are receiving /have received (support agency, level of support, name & contact details)",
                                                }
                                            },
                                            {
                                                expressions: {
                                                    hide: (field: FormlyFieldConfig) => !(field.model.applicationForm == 'general')
                                                },
                                                key: "sensoryDisability",
                                                type: "radiobuttons",
                                                props: {
                                                    options: this.yesNoMap,
                                                    labelHtmlClass: "control-label",
                                                    activeClass: "active",
                                                    required: true,
                                                    title: "Do you suffer from a sensory disability (deafness, impaired sight, etc)"
                                                },
                                            },
                                            {
                                                expressions: {
                                                    hide: (field: FormlyFieldConfig) => !(field.model.applicationForm == 'ops')
                                                },
                                                key: "visionDisability",
                                                type: "radiobuttons",
                                                props: {
                                                    options: this.yesNoMap,
                                                    labelHtmlClass: "control-label",
                                                    activeClass: "active",
                                                    required: true,
                                                    title: "Do you suffer from a disability with your vision?"
                                                },
                                            },
                                            {
                                                expressions: {
                                                    hide: (field: FormlyFieldConfig) => !(field.model.visionDisability == true && field.model.applicationForm == 'ops')
                                                },
                                                key: "visionDisabilityInfo",
                                                type: "textarea",
                                                props: {
                                                    required: true,
                                                    title: "Please provide details of how it affects/has affected your daily life and details of any support you are receiving /have received (support agency, level of support, name & contact details)",
                                                }
                                            },
                                            {
                                                expressions: {
                                                    hide: (field: FormlyFieldConfig) => !(field.model.applicationForm == 'ops')
                                                },
                                                key: "hearingDisability",
                                                type: "radiobuttons",
                                                props: {
                                                    options: this.yesNoMap,
                                                    labelHtmlClass: "control-label",
                                                    activeClass: "active",
                                                    required: true,
                                                    title: "Do you suffer from a disability with your hearing?"
                                                },
                                            },
                                            {
                                                expressions: {
                                                    hide: (field: FormlyFieldConfig) => !(field.model.hearingDisability == true && field.model.applicationForm == 'ops')
                                                },
                                                key: "hearingDisabilityInfo",
                                                type: "textarea",
                                                props: {
                                                    required: true,
                                                    title: "Please provide details of how it affects/has affected your daily life and details of any support you are receiving /have received (support agency, level of support, name & contact details)",
                                                }
                                            },
                                            {
                                                key: "alcoholAndOrSubstanceMisuse",
                                                type: "radiobuttons",
                                                props: {
                                                    options: this.yesNoMap,
                                                    labelHtmlClass: "control-label",
                                                    activeClass: "active",
                                                    required: true,
                                                    title: "Do you/have you suffered from alcohol and/or substance misuse?"
                                                },
                                            },
                                            {
                                                expressions: {
                                                    hide: (field: FormlyFieldConfig) => !(field.model.alcoholAndOrSubstanceMisuse == true && field.model.applicationForm == 'ops')
                                                },
                                                key: "alcoholAndOrSubstanceMisuseInfo",
                                                type: "textarea",
                                                props: {
                                                    required: true,
                                                    title: "Please provide details of how it affects/has affected your daily life and details of any support you are receiving /have received (support agency, level of support, name & contact details)",
                                                }
                                            },
                                            {
                                                key: "mentalHealthIssue",
                                                type: "radiobuttons",
                                                props: {
                                                    options: this.yesNoMap,
                                                    labelHtmlClass: "control-label",
                                                    activeClass: "active",
                                                    required: true,
                                                    title: "Do you/have you suffered from a mental health issue?"
                                                },
                                            },
                                            {
                                                expressions: {
                                                    hide: (field: FormlyFieldConfig) => !(field.model.mentalHealthIssue == true && field.model.applicationForm == 'ops')
                                                },
                                                key: "mentalHealthIssueInfo",
                                                type: "textarea",
                                                props: {
                                                    required: true,
                                                    title: "Please provide details of how it affects/has affected your daily life and details of any support you are receiving /have received (support agency, level of support, name & contact details)",
                                                }
                                            },
                                            {
                                                key: "selfHarm",
                                                type: "radiobuttons",
                                                props: {
                                                    options: this.yesNoMap,
                                                    labelHtmlClass: "control-label",
                                                    activeClass: "active",
                                                    required: true,
                                                    title: "Have you/do you self-harm?"
                                                },
                                            },
                                            {
                                                expressions: {
                                                    hide: (field: FormlyFieldConfig) => !(field.model.selfHarm == true && field.model.applicationForm == 'ops')
                                                },
                                                key: "selfHarmInfo",
                                                type: "textarea",
                                                props: {
                                                    required: true,
                                                    title: "Please provide details of how it affects/has affected your daily life and details of any support you are receiving /have received (support agency, level of support, name & contact details)",
                                                }
                                            },
                                            {
                                                key: "domesticOrFinancialAbuse",
                                                type: "radiobuttons",
                                                props: {
                                                    options: this.yesNoMap,
                                                    labelHtmlClass: "control-label",
                                                    activeClass: "active",
                                                    required: true,
                                                    title: "Do you/have you suffered domestic or financial abuse?"
                                                },
                                            },
                                            {
                                                expressions: {
                                                    hide: (field: FormlyFieldConfig) => !(field.model.domesticOrFinancialAbuse == true && field.model.applicationForm == 'ops')
                                                },
                                                key: "domesticOrFinancialAbuseInfo",
                                                type: "textarea",
                                                props: {
                                                    required: true,
                                                    title: "Please provide details of how it affects/has affected your daily life and details of any support you are receiving /have received (support agency, level of support, name & contact details)",
                                                }
                                            },
                                            {
                                                key: "socialCareInvolvement",
                                                type: "radiobuttons",
                                                props: {
                                                    options: this.yesNoMap,
                                                    labelHtmlClass: "control-label",
                                                    activeClass: "active",
                                                    required: true,
                                                    title: "Do you/have you had involvement with Social Care (Child in need, Child protection , Adult Services, etc)?"
                                                },
                                            },
                                            {
                                                expressions: {
                                                    hide: (field: FormlyFieldConfig) => !(field.model.socialCareInvolvement == true && field.model.applicationForm == 'ops')
                                                },
                                                key: "socialCareInvolvementInfo",
                                                type: "textarea",
                                                props: {
                                                    required: true,
                                                    title: "Please provide details of how it affects/has affected your daily life and details of any support you are receiving /have received (support agency, level of support, name & contact details)",
                                                }
                                            },
                                            {
                                                expressions: {
                                                    hide: (field: FormlyFieldConfig) => !(field.model.applicationForm == 'general')
                                                },
                                                key: "socialCareInvolvementDetails",
                                                type: "textarea",
                                                props: {
                                                    required: true,
                                                    title: "Please provide details of how it affects/has affected your daily life and details of any support you are receiving /have received (support agency, level of support, name & contact details)",
                                                }
                                            },
                                            {
                                                key: "haveYouEverHeldATenancyBefore",
                                                type: "radiobuttons",
                                                props: {
                                                    options: this.yesNoMap,
                                                    labelHtmlClass: "control-label",
                                                    activeClass: "active",
                                                    required: true,
                                                    title: "Have you ever held a tenancy before?"
                                                },
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    }
}
